import { ComponentProps } from 'react';
import { CTAButton } from 'src/general/components/Button/CTAButton';
import { ValuePropLineItem } from 'src/hygiene/components/ValuePropLineItem/ValuePropLineItem';

type PerkContentProps = {
  header: string;
  subHeader: string;
  lines: ComponentProps<typeof ValuePropLineItem>[];
  cta?: ComponentProps<typeof CTAButton>[];
};

export const PerkContent: React.FC<PerkContentProps> = ({ header, subHeader, lines, cta }) => {
  return (
    <section className="flex w-full flex-col gap-4">
      <header className="flex w-full flex-col gap-2">
        <h2 className="c-fs-h4 font-extrabold">{header}</h2>
        <p className="c-fs-h6">{subHeader}</p>
      </header>
      <div className="flex w-full flex-col gap-2">
        {lines.map((line, index) => (
          <ValuePropLineItem key={`${line.lineItem}-${index}`} {...line} />
        ))}
      </div>
      {cta?.length && <CTAButton {...cta[0]} />}
    </section>
  );
};
